module.exports = __webpack_public_path__ + "img/bj1.2f515082.png";